import { AbilityRef } from "../lib/db/types.js";
import { Ruleset } from "./ruleset.js";
import { Unit } from "./unit.js";

export type AbilityDef = {
  id: string;
  name: string;
  unit_cost: number;
  description: string;
};

export class Ability {
  readonly ruleset: Ruleset;
  readonly owner: Unit;
  readonly definition: AbilityDef;

  constructor(owner: Unit, abilityDef: AbilityDef) {
    this.ruleset = owner.ruleset;
    this.owner = owner;
    this.definition = abilityDef;
  }

  get id() {
    return this.definition.id;
  }

  get name() {
    return this.definition.name;
  }

  get cost() {
    return this.definition.unit_cost;
  }

  get summary() {
    return `${this.cost}pts · ${this.definition.description}`;
  }

  static from(owner: Unit, abilityRef: AbilityRef) {
    const abilityDef = owner.ruleset.abilityDefs.get(abilityRef.id);

    if (!abilityDef) {
      return null;
    }

    return new Ability(owner, abilityDef);
  }
}
